import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';

interface IPageMr0012 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}
/* @ngInject */
export default function Mr0012Controller(
    mr2024Route: IRoute
) {
    const vm: IPageMr0012 = this;

    vm.multiOccurrenceOptions = {
        fonctions: {
            rechercheCollapsable: false
        },
        navigatePage: mr2024Route.NAME,
        navigateParams:(rowdata:any)=>({
            id:rowdata.sidcleint,
            sidcleint:rowdata.sidcleint
        }),
        colonnesVisibles: [
            { nom: 'siddsc', largeur: 110 },
            { nom: 'ecrcod', largeur: 240 },
            { nom: 'ecrdsc', largeur: 240 },
            { nom: 'siddscnul', largeur: 240 },
            { nom: 'sidinddem', largeur: 50 }
        ],
        colonnesCachees:['sidcleint']
    };
}

